import React from "react";
import { useTranslation } from "react-i18next";

import { TextInput } from "@common/textInput";
import { Unit } from "@common/unit";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import styles from "./styles.scss";

function CostInput({ cost, input }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.costInput}>
      <TextInput
        value={typeof cost !== "undefined" ? `${cost}` : ""}
        className={styles.input}
        placeholder=""
        input={(cost) => input(cost === "" ? undefined : parseFloat(cost))}
      />
      <p className={styles.placeholder}>
        <Unit unit="currency:euro" />/<AllocationUnit format="text" />
      </p>
    </div>
  );
}

export { CostInput };
